import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { setCurrentRoute } from '../../actions/authActions';
// import Filter from './filter';

class SidebarContent extends Component {

    onSetSidebarOpen(open) {
        // console.log(this)
        this.props.toggleSiderBarOpen(!this.props.sideBarOpen)
    }

    render() {
        return (
            <div>
                <ListGroup >
                    <ListGroupItem disabled={this.props.routeName==="locate_sites"} onClick={this.props.setCurrentRoute.bind(this, "locate_sites")} action>Locate Sites</ListGroupItem>
                    <ListGroupItem disabled={this.props.routeName==="show_created_campaign"} onClick={this.props.setCurrentRoute.bind(this, "show_created_campaign")} action>Show Campaigns</ListGroupItem>
                    {/* <ListGroupItem disabled={this.props.routeName==="show_shared_campaign"} onClick={this.props.setCurrentRoute.bind(this, "show_shared_campaign")} action>Shared Campaigns</ListGroupItem> */}
                    <ListGroupItem disabled={this.props.routeName==="create_plano_campaign"} onClick={this.props.setCurrentRoute.bind(this, "create_plano_campaign")} action>Create Campaign</ListGroupItem>
                  
                </ListGroup>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    // console.log(state.auth)
    return {
        routeName: state.auth.routeName,
    }
}

export default connect(mapStateToProps, { setCurrentRoute })(SidebarContent);


// WEBPACK FOOTER //
// ./src/v3/components/createCampaign/sideBarContent.js